export const ACHIEVEMENT_TRANSLATIONS_ID = {
  "never-empty-handed": {
    "name": "Never Empty-Handed",
    "description": "Hobi Fishing mencapai Lv. 10",
    "titleGained": "Skilled Angler",
  },
  "mystic-fisher": {
    "name": "Mystic Fisher",
    "description": "Memicu fase tersembunyi Acara Fishing sebanyak 10 kali.",
    "titleGained": "Fisher",
  },
  "shoals-blessing": {
    "name": "Shoal's Blessing",
    "description": "Memicu total 100 Shoal selama Acara Fishing.",
    "titleGained": "Blessing",
  },
  "strong-sailor": {
    "name": "Strong Sailor",
    "description": "Tangkap ikan lebih dari 100kg selama 2 kali berturut-turut.",
    "titleGained": "Fishing Line",
  },
  "twin-fish-fortune": {
    "name": "Twin Fish Fortune",
    "description": "Tangkap 2 ikan Bintang 5 dalam 1 menit.",
    "titleGained": "Osprey",
  },
  "fishing-machine": {
    "name": "Fishing Machine",
    "description": "Tangkap total 50 ikan dengan berat masing-masing lebih dari 100kg.",
    "titleGained": "Fish Basket",
  },
  "shark-frenzy": {
    "name": "Shark Frenzy",
    "description": "Tangkap 3 hiu dari bayangan ikan emas dalam satu Acara Sea Fishing.",
    "titleGained": "Shark Cage",
  },
  "shoal-caller": {
    "name": "Shoal Caller",
    "description": "Memicu 3 Shoals dalam satu Acara Fishing.",
    "titleGained": "Shoal Caller",
  },
  "starlight-fisher": {
    "name": "Starlight Fisher",
    "description": "Tangkap 4 ikan Bintang 5 dalam satu Acara Fishing.",
    "titleGained": "Fishing Maniac",
  },
  "town-cooking-legend": {
    "name": "Town Cooking Legend",
    "description": "Hobi Cooking mencapai Lv. 10.",
    "titleGained": "Chef",
  },
  "fast-and-flawless": {
    "name": "Fast & Flawless",
    "description": "Masak 2 hidangan Bintang 5 dalam waktu 60 detik.",
    "titleGained": "Kitchen Clock",
  },
  "green-touch": {
    "name": "Green Touch",
    "description": "Hobi Gardening mencapai Lv. 10.",
    "titleGained": "Horticulturist",
  },
  "plentiful-harvest": {
    "name": "Plentiful Harvest",
    "description": "Panen tanaman bintang 5 saat Bonus Harvest aktif.",
    "titleGained": "Harvest",
  },
  "rainbow-luck": {
    "name": "Rainbow Luck",
    "description": "Memicu 2 Berkah Hibrida Pelangi dalam satu penyiraman multi-area.",
    "titleGained": "Rainbow Luck",
  },
  "ace-cat-servant": {
    "name": "Ace Cat Servant",
    "description": "Hobi Merawat Kucing mencapai Lv. 10.",
    "titleGained": "Cat Lover",
  },
  "meow-meow-canteen": {
    "name": "Meow-Meow Canteen",
    "description": "Beri makan 5 kucing makanan favoritnya.",
    "titleGained": "Cat Food",
  },
  "ace-dog-trainer": {
    "name": "Ace Dog Trainer",
    "description": "Hobi Peduli Anjing mencapai Lv. 10.",
    "titleGained": "Dog Pal",
  },
  "doggie-canteen": {
    "name": "Doggie Canteen",
    "description": "Beri makan 3 anjing makanan favorit mereka.",
    "titleGained": "Dog Food",
  },
  "insect-commander": {
    "name": "Insect Commander",
    "description": "Hobi Insect Catching mencapai Lv. 10.",
    "titleGained": "Insect Master",
  },
  "mystic-tracker": {
    "name": "Mystic Tracker",
    "description": "Memicu fase tersembunyi di Acara Insect Catching sebanyak 10 kali.",
    "titleGained": "Exploration",
  },
  "swarm-commander": {
    "name": "Swarm Commander",
    "description": "Memicu total 100 Swarm yang masuk selama Acara Insect Catching.",
    "titleGained": "Swarm",
  },
  "insect-harvester": {
    "name": "Insect Harvester",
    "description": "Tangkap 3 serangga dengan satu gelembung penangkap serangga.",
    "titleGained": "Triple Catch",
  },
  "five-insects-blessing": {
    "name": "Five Insects Blessing",
    "description": "Tangkap 5 serangga Bintang 5 dalam satu Acara Insect Catching.",
    "titleGained": "Insect Lord",
  },
  "human-insect-attractor": {
    "name": "Human Insect Attractor",
    "description": "Memicu 4 Swarm dalam satu event Insect Catching.",
    "titleGained": "Insect Attractor",
  },
  "bird-whisperer": {
    "name": "Bird Whisperer",
    "description": "Hobi Birdwatching mencapai Lv. 10.",
    "titleGained": "Bird Whisperer",
  },
  "cloud-walker": {
    "name": "Cloud Walker",
    "description": "Memicu fase tersembunyi Acara Birdwatching sebanyak 10 kali.",
    "titleGained": "Sky",
  },
  "harmony-with-breeze": {
    "name": "Harmony with Breeze",
    "description": "Memicu total 100 Gelombang Burung selama Acara Birdwatching.",
    "titleGained": "Resonance",
  },
  "joyful-chorus": {
    "name": "Joyful Chorus",
    "description": "Memicu 3 Gelombang Burung dalam satu Acara Birdwatching.",
    "titleGained": "Feather",
  },
  "decisive-moment": {
    "name": "Decisive Moment",
    "description": "Dapatkan 10 Kartu Info Bintang 5 dalam satu Acara Birdwatching.",
    "titleGained": "Moment",
  },
  "sand-sculpture-artist": {
    "name": "Sand Sculpture Artist",
    "description": "Hobi Memahat Pasir mencapai Lv. 5.",
    "titleGained": "Sand Sculptor",
  },
  "pumpkinarchy": {
    "name": "Pumpkinarchy",
    "description": "Hobi Mengukir Labu mencapai Lv. 5.",
    "titleGained": "Pumpkin Head",
  },
  "snow-king": {
    "name": "Snow King",
    "description": "Hobi Memahat Salju mencapai Lv. 5.",
    "titleGained": "Snow King",
  },
  "collector": {
    "name": "Collector",
    "description": "Menjadi Ahli Collector.",
    "titleGained": "Collector",
  },
  "rocket-sponsor": {
    "name": "Rocket Sponsor",
    "description": "Hasilkan total 500.000 Gold dengan menjual item ke Gold Merchant Albert Jr.",
    "titleGained": "Rocket",
  },
  "dg-member": {
    "name": "D.G. Member",
    "description": "Level D.G. Member mencapai Lv. 30.",
    "titleGained": "D.G. Member",
  },
  "puzzle-artist": {
    "name": "Puzzle Artist",
    "description": "Menjadi Artis Teka-Teki.",
    "titleGained": "Puzzle",
  },
  "persistent-quill": {
    "name": "Persistent Quill",
    "description": "Menulis Mimpi mencapai Guru.",
    "titleGained": "Writing",
  },
  "golden-music-cd": {
    "name": "Golden Music CD",
    "description": "Music Dream mencapai CD Musik Golden.",
    "titleGained": "Music",
  },
  "animal-neighbour": {
    "name": "Animal Neighbour",
    "description": "Capai Bond Level 10 dengan 8 kelompok hewan.",
    "titleGained": "New Neighbour",
  },
  "stardust-collector": {
    "name": "Stardust Collector",
    "description": "Kumpulkan 60 Starfall Shard.",
    "titleGained": "Star Picker",
  },
  "animal-keeper": {
    "name": "Animal Keeper",
    "description": "Temukan makanan favorit untuk 8 kelompok hewan.",
    "titleGained": "Delicious",
  },
  "ice-elf": {
    "name": "Ice Elf",
    "description": "Gambar Skating Mimpi raches Ice Elf.",
    "titleGained": "Ice Skating",
  },
  "mystery-onsen-buddy": {
    "name": "Onsen Buddy",
    "description": "Masuk ke Onsen bersama seorang teman.",
  },
  "mystery-friendship-under-the-meteor": {
    "name": "Friendship Under the Meteor",
    "description": "Di Persahabatan Lv. 5, gunakan emote Wish bersama teman saat cuaca Hujan Meteor.",
  },
  "mystery-super-star": {
    "name": "Super Star",
    "description": "Dapatkan 100 suka di rumah Anda.",
  },
  "mystery-repair-expert": {
    "name": "Repair Expert",
    "description": "Bagikan 100 kit perbaikan.",
  },
  "mystery-food-diplomat": {
    "name": "Food Diplomat",
    "description": "Bagikan makanan 100 kali.",
  },
  "mystery-wholesaler-of-grasslands": {
    "name": "Wholesaler of Grasslands",
    "description": "Bagikan semak kamuflase 100 kali.",
  },
  "mystery-insect-hunting-party": {
    "name": "Insect Hunting Party",
    "description": "Bagikan daya tarik serangga yang menggembung 100 kali.",
  },
  "mystery-rainbow-volunteer": {
    "name": "Rainbow Volunteer",
    "description": "Bagikan buket pelangi 50 kali.",
  },
  "onsen-buddy": {
    "name": "Onsen Buddy",
    "description": "Ambil Onsen bersama teman-teman.",
    "titleGained": "Onsen",
    "hint": "Akui uap yang berputar-putar, persahabatan diam-diam semakin dalam.",
  },
  "mystery-best-selling-author": {
    "name": "Best Selling Author",
    "description": "Jual total 1000 buku.",
  },
  "mystery-great-author": {
    "name": "Great Author",
    "description": "Tulis setidaknya 10 buku, masing-masing dengan 200 penjualan.",
  },
  "mystery-bookcase-full": {
    "name": "Bookcase Full (Unconfirmed)",
    "description": "Belum dikonfirmasi: petunjuk menyebutkan rak buku Anda semakin penuh.",
  },
  "mystery-sea-fishing-grand-slam": {
    "name": "Sea Fishing Grand Slam",
    "description": "Kumpulkan semua judul akhir acara dari acara harian Sea Fishing.",
  },
  "mystery-onsen-mountain-insect-hunter": {
    "name": "Onsen Mountain Insect Hunter",
    "description": "Kumpulkan semua judul akhir acara dari acara harian Bait the Insects.",
  },
} as const;
